import { createContext, useContext, useMemo } from 'react';
import type { AgentMode } from '@tabbio/types';
import { agentMessageDisplayText } from '@/lib/agent-capabilities-mentions';

/**
 * The mode the chat runtime sends with (seeker or employer), for the parts of
 * the thread that must agree with what was sent. Provided by `ChatProvider`
 * on web and native.
 */
export const AgentChatModeContext = createContext<AgentMode>('seeker');

/**
 * A user message's text as the thread shows it: the mentions the runtime
 * removed before sending are removed here too, from the first frame, so the
 * bubble reads the same before and after a reload. `allowEmpty` mirrors the
 * phone's runtime for a message with attachments (see
 * `readAgentMessageCapabilities`).
 */
export function useAgentMessageDisplayText(text: string, options: { allowEmpty?: boolean } = {}): string {
  const mode = useContext(AgentChatModeContext);
  const allowEmpty = options.allowEmpty ?? false;
  return useMemo(() => agentMessageDisplayText(mode, text, { allowEmpty }), [allowEmpty, mode, text]);
}
